module.exports = __webpack_public_path__ + "static/media/ProgramLogo.e6170b6a.png";